var _path, _path2, _path3, _path4;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import React from "react";
var SvgGoogleWorkspace = function SvgGoogleWorkspace(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.6989 32.2364C51.6989 30.7644 51.5669 29.3478 51.3214 27.9893H31.7646V36.0216H42.9398C42.4585 38.6172 40.9953 40.816 38.7965 42.2888V47.4985H45.5073C49.4341 43.8832 51.6989 38.56 51.6989 32.2364Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7649 52.5297C37.3714 52.5297 42.0716 50.6706 45.5075 47.4987L38.7968 42.289C36.9376 43.5349 34.5584 44.2713 31.7649 44.2713C26.3563 44.2713 21.7793 40.619 20.1462 35.7102H13.2085V41.0906C16.625 47.877 23.6472 52.5297 31.7649 52.5297Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1462 35.71C19.7309 34.4641 19.4951 33.1329 19.4951 31.7647C19.4951 30.3965 19.7309 29.0652 20.1462 27.8193V22.439H13.2085C11.8024 25.2422 11 28.4141 11 31.7647C11 35.1152 11.8024 38.2871 13.2085 41.0904L20.1462 35.71Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7649 19.2584C34.8136 19.2584 37.5509 20.3063 39.703 22.3635L45.6588 16.4077C42.0619 13.058 37.3617 11 31.7649 11C23.6481 11 16.625 15.6536 13.2085 22.4391L20.1462 27.8195C21.7793 22.9116 26.3572 19.2584 31.7649 19.2584Z",
    fill: "#EA4335"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGoogleWorkspace, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/google-workspace.1c6dd86884f8244dce460f01bf4382a7.svg";
export { ForwardRef as ReactComponent };